export const  tableData = [
    {
       "category":"Loan Amount Sanctioned",
       "FY25":143,
       "FY24": 121,
       "FY23": 93,
    },
    {
      "category":"Loan Amount Disbursed",
      "FY25":143,
      "FY24": 121,
      "FY23": 93,
   },
   {
      "category":"Asset NII Earned",
      "FY25":143,
      "FY24": 121,
      "FY23": 93,
   },
   {
      "category":"Avg. Yield",
      "FY25":143,
      "FY24": 121,
      "FY23": 93,
   },
   {
      "category":"Liability NII Earned",
      "FY25":143,
      "FY24": 121,
      "FY23": 93,

   },
   {
      "category":"Fee Income",
      "FY25":143,
      "FY24": 121,
      "FY23": 93,

   },
   {
      "category":"Other Income",
      "FY25":143,
      "FY24": 121,
      "FY23": "",
   }
 ]